import React, {useContext} from 'react';
import { MainContext } from '../../../contexts/MainContext';
import CustomSwitch from '../../custom-switch/CustomSwitch';
import "./DistancesSwitch.scss"
import "./Adaptations.scss"

export default function DistancesSwitch(){

    const {
        showDistances,
        setShowDistances,
    } = useContext(MainContext);
  return (
    <div className="switch-con">
        <label className="switch-label">
            <CustomSwitch 
                activeState={showDistances}
                onClick={() => setShowDistances((prev) => !prev)}
            />
            <span
                onClick={() => setShowDistances((prev) => !prev)}
            >
                show distances
            </span>
        </label>
    </div>
  );
};
